import { SET_SELECTED_PATIENT } from './patientActionTypes';

const initialState = {
  selectedPatientId: null
};

const patientReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_PATIENT:
      return {
        ...state,
        selectedPatientId: action.payload
      };
    default:
      return state;
  }
};

export default patientReducer;
